export enum LoginType {
  Password,
  Saml,
  UnexpectedFailure
}
